var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M22.221 6.913a2.648 2.648 0 0 0-1.864-1.869c-1.644-.44-8.237-.44-8.237-.44s-6.59 0-8.236.44a2.648 2.648 0 0 0-1.865 1.87C1.579 8.56 1.579 12 1.579 12s0 3.44.44 5.087a2.648 2.648 0 0 0 1.865 1.87c1.646.44 8.236.44 8.236.44s6.593 0 8.237-.44a2.648 2.648 0 0 0 1.864-1.87c.44-1.647.44-5.087.44-5.087s0-3.44-.44-5.087Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.014 15.171 5.477-3.17-5.477-3.171v6.341Z"
  })));
};
export default SvgIconYoutube;